import React from 'react';
import styles from './CMDashboard.module.css';
import moment from 'moment';
import {
  ApplicantHeading,
  CardHeading
} from '../../components/CompanyDetailsCMView/CompanyDetailsCMView';

const { professional_data, professional_container, widthFit } = styles;

const CMProfessionalDataBoard = ({ each, index }) => {
  return (
    <div className="w-full bg-white my-3">
      {index === 0 ? (
        <ApplicantHeading heading="Main Applicant" />
      ) : (
        <ApplicantHeading heading={`Co-applicant ${index}`} />
      )}
      {each?.professionType === 'SALARIED' && (
        <div className="w-full px-4 py-6 my-3  bg-white shadow-md  rounded-md border border-grey-1009">
          <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Company Name
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.companyName || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Official Mail ID{' '}
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.officialEmail || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Designation
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.designation || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Highest Qualification
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.highestQualificaton || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Total Work experience
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.totalWorkExperience || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Total years in Present company
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.yearsInCurrentCompany || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Company Address
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.companyAddress || 'NA'}
              </p>
            </div>
          </div>
        </div>
      )}
      {each?.professionType === 'SELF_EMPLOYED' && (
        <div className="w-full px-4 py-6 my-3  bg-white shadow-md  rounded-md border border-grey-1009">
          <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                CIN
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.cin || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Company Name
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.companyName || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Company PAN
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.companyPan || 'NA'}
              </p>
            </div>

            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Company Type
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.companyType || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Gst Number
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.gstNumber || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Highest Qualification
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.highestQualificaton || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Industry
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.industry || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Nature Of Business
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.natureOfBusiness || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Profession Type
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.professionType || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Sub Industry
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.subIndustry || 'NA'}
              </p>
            </div>
          </div>
        </div>
      )}
      {each?.professionType === 'SELF_EMPLOYED_PROFESSIONAL' && (
        <div className="w-full px-4 py-6 my-3  bg-white shadow-md  rounded-md border border-grey-1009">
          <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Commencement Date
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.commencementDate
                  ? moment(each?.commencementDate).format('ll')
                  : 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                CP Number
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.cpNumber || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Firm Name
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.firmName || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Highest Qualification
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.highestQualificaton || 'NA'}
              </p>
            </div>

            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Medical Council
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.medicalCouncil || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Profession
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.profession || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Profession Registered Number
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.professionRegisteredNumber || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Profession Registered Year
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.professionRegisteredYear || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Profession Type
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.professionType || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Professional Qualification
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.professionalQualification || 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                registrationDate
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.registrationDate
                  ? moment(each?.registrationDate).format('ll')
                  : 'NA'}
              </p>
            </div>
            <div className={`block w-4/12  my-2 ${professional_data}`}>
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Worker Count
              </p>
              <p className="text-black-400 font-roboto tet-base font-medium ">
                {each?.workerCount || 'NA'}
              </p>
            </div>
          </div>
        </div>
      )}
      {each?.professionType !== 'SELF_EMPLOYED_PROFESSIONAL' &&
        each?.professionType !== 'SELF_EMPLOYED' &&
        each?.professionType !== 'SALARIED' && (
          <div className="w-full px-4 py-6 my-3  bg-white shadow-md  rounded-md border border-grey-1009">
            <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
              <div className={`block w-4/12  my-2 ${professional_data}`}>
                <p className="text-black-400 font-roboto tet-base font-medium ">
                  Oops! something went wrong ! !
                </p>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default CMProfessionalDataBoard;
